import { useEffect } from 'react';
import { Outlet, ScrollRestoration, useNavigation } from 'react-router-dom';
import useVideoStore from 'stores/videoStore';
import Header from 'components/Header';
import Footer from 'components/Footer';
import LoadingScreen from 'components/LoadingScreen';

export default function Layout() {
  const navigation = useNavigation();
  const videoHeader = useVideoStore((state) => state.videoLoaded);

  useEffect(() => {
    // set dark mode as the default mode
    const root = document.getElementsByTagName('html')[0];
    root.classList.add('dark');
  }, []);

  return (
    <>
      {(navigation.state === 'loading' && !videoHeader)
        ? <LoadingScreen />
        : (
          <>
            <Header />
            <Outlet />
            <Footer />
            <ScrollRestoration />
          </>
        )}
    </>
  );
}